<div class="product-container col-lg-3 col-xs-8">
  <div class="product-content">
    <div
      class="image-container col-xs-12"
      [routerLink]="[
        '/box-options',
        categoryCode,
        subcategory.code,
        uploadDesign  
      ]"
      [ngStyle]="{ background: 'url(&quot;' + getDefaultPicture(subcategory) + '&quot;)' }"
      (mouseover)="showGIF($event.target, subcategory)"
      (mouseleave)="showStaticPicture($event.target, subcategory)"
    ></div>
    <h2 class="product-header" [innerHTML]="subcategory.name"></h2>
    <div
      class="product-description"
      [innerHTML]="subcategory?.data[0]?.value"
    ></div>
    <div class="button-container">
      <div
        class="link-container chevron-anchor red border"
        [routerLink]="[
          '/box-options',
          categoryCode,
          subcategory.code,
          uploadDesign
        ]"
      >
        <a
          [routerLink]="[
            '/box-options',
            categoryCode,
            subcategory.code,
            uploadDesign
          ]"
          [attr.aria-label]="'Create ' + plainName"
          >Create</a
        >
      </div>
    </div>
  </div>
</div>
